// Get the width (in EMs/REMs) at which the full menu should be shown
let breakpointToDesktopNav;
breakpointToDesktopNav = 72;